import { useEffect, FC, useMemo } from 'react';
import { StripePaymentForm } from './StripePaymentForm';
import {
  CreateStripePaymentMutationResponse,
  useCreateStripePaymentMutation,
} from '../../hooks/useCreateStripePaymentMutation';
import { FormSkeleton } from '../../../../components/Skeleton';
import { ViewStateType } from '../../../../components/ProductTemplates/types';
import { logError } from '../../../../components/LogError';
import StripeContainer from '.';
import { ModelType } from '../../types';
import { stripeThemeAppearance } from './helpers';

interface StripeOTPProps {
  request: Parameters<CreateStripePaymentMutationResponse['execute']>[0];
  onCTA?: (viewState: ViewStateType) => void;
  model: ModelType;
}

const StripeOTP: FC<StripeOTPProps> = ({ request, onCTA, model }) => {
  const { execute, error, loading, data } = useCreateStripePaymentMutation();

  const stripeResponse = useMemo(() => {
    if (!data) return { paymentIntentId: '', options: null };
    const { clientSecret, paymentIntentId } = data.createStripePayment;
    return {
      paymentIntentId,
      options: {
        clientSecret,
        appearance: { ...stripeThemeAppearance },
      } as const,
    };
  }, [data]);

  useEffect(() => {
    execute(request);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onError = (err: unknown) => {
    logError(err as Error);
    if (onCTA) {
      onCTA(ViewStateType.ERROR_RESULT);
    }
  };

  useEffect(() => {
    if (error) {
      onError(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return (
    <div>
      {loading && <FormSkeleton />}
      {!loading && stripeResponse.options && stripeResponse.options.clientSecret && (
        <StripeContainer options={stripeResponse.options}>
          <StripePaymentForm onError={onError} model={model} />
        </StripeContainer>
      )}
    </div>
  );
};

export default StripeOTP;
